import { render } from "./ProspectFamily.vue?vue&type=template&id=d6e75d72"
import script from "./ProspectFamily.vue?vue&type=script&lang=js"
export * from "./ProspectFamily.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__